import styled, { keyframes } from 'styled-components';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';

export const ChatSectionStyled = styled.div`
  width: 100%;
  height: calc(100vh - 145px);
  display: flex;
  overflow: auto;
  position: relative;

  /* &.sources-active {
    @media (min-width: 992px) {
      padding: 0 290px 0 0;
    }
    @media (min-width: 1400px) {
      padding: 0 390px 0 0;
    }
    @media (min-width: 1600px) {
      padding: 0 490px 0 0;
    }
  } */
`;

const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export const ChatColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  padding: 0 5px 0 0;

  .error-text {
    color: var(--danger);
  }

  .chat-loader-text {
    display: block;
    font-weight: 400;
    margin-bottom: 10px;
    animation: ${pulse} 1.5s ease-in-out infinite;
  }

  .text-block {
    flex-grow: 1;
    height: 100vh;
    overflow: auto;
    padding: 15px 5px 15px 0;
    .user-text {
      position: relative;
      padding-right: 100px;
      .see-source-button {
        padding: 5px 8px;
        color: var(--black);
        background: var(--white);
        border-radius: 8px;
        position: absolute;
        right: 0;
        top: 0px;
      }
    }
    .heading {
      margin: 0 0 30px;
      position: relative;
      padding-left: 55px;
      line-height: 28px;
      a {
        text-decoration: underline;
        color: var(--primary-50);
      }

      .icon-box {
        position: absolute;
        left: 0;
        top: -10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        font-size: 20px;
        line-height: 23px;
        font-weight: 700;
        text-transform: uppercase;
        border-radius: 50px;
        color: var(--text-color);
        background: var(--white);
        &--purple {
          background: rgb(135 137 147 / 48%);
          overflow: hidden;
        }
      }

      table {
        border-collapse: collapse;
        width: max-content;
      }
      th,
      td {
        border: 1px solid var(--line);
        border-spacing: 0;
        padding: 5px;
        text-align: left;
      }

      /* tr {
        &:first-child {
          background-color: var(--card-bg);
        }
        &:nth-child(even) {
          background-color: transparent;
        }
      } */

      .lucide-download {
        display: none;
      }

      .title {
        display: block;
        margin: 0;
      }

      pre {
        background-color: #1e1e1e;
        color: #f8f8f2;
        padding: 16px;
        border-radius: 8px;
        font-family: 'Fira Code', 'Source Code Pro', monospace;
        font-size: 16px;
        line-height: 26px;
        margin-top: 10px;
        margin-bottom: 10px;
        border: 1px solid #333;

        &::-webkit-scrollbar {
          height: 8px;
        }
        &::-webkit-scrollbar-thumb {
          background: #555;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: #777;
        }
      }
    }

    .title {
      display: block;
      font-size: 20px;
      line-height: 24px;
      font-weight: 700;
      margin: 0 0 20px;
    }

    .text-box {
      width: 100%;
      margin: 0 0 20px;
    }

    .detail-box {
      width: 100%;
      padding: 20px 0;
      border-top: 1px solid #cdcdcd;

      .list {
        margin: 0;
        padding: 0 0 0 15px;

        li {
          margin: 0 0 15px;
        }
      }
    }

    .reponse-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      .agent-name {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: var(--text-color);
        padding: 8px 15px;
        border-radius: 10px;
        background: var(--white);
      }

      .action-list {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;

        li {
          margin: 0;
        }

        button {
          font-size: 22px;
          line-height: 1;
          color: var(--light-gray);

          &:hover {
            color: var(--text-color);
          }
        }
      }
    }
  }

  .swiper-holder {
    position: relative;

    .swiper {
      padding-top: 20px;
      margin-bottom: 20px;
      overflow: hidden;
      /* .swiper-wrapper {
      display: flex;
      gap: 12px;
      overflow: hidden;
    } */
      .swiper-slide {
        /* cursor: pointer;
      margin: 0 !important; */

        .img-wrap {
          display: block;
          width: 200px !important;
          height: 150px;
          overflow: hidden;
          border-radius: 10px;
          border: 1px solid #cdcdcd;

          @media (min-width: 768px) {
            width: 300px !important;
            height: 200px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .swiper-controls {
      display: flex;
      gap: 10px;
    }

    .swiper-controls button {
      position: absolute;
      top: 50%;
      right: 10px;
      left: auto;
      width: 30px;
      height: 30px;
      background: #f1f1f9;
      color: var(--black);
      border-radius: 50%;
      border: none;
      cursor: pointer;

      &::after {
        display: none;
      }
      svg {
        width: 20px;
      }
    }

    .swiper-button-prev {
      right: auto !important;
      left: 10px !important;
    }
  }
`;

export const SearchResultCol = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  flex-shrink: 0;
  width: 300px;
  padding: 10px 20px;
  border-left: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--card-bg);
  z-index: 999;

  @media (min-width: 1200px) {
    width: 500px;
  }
  .content-box {
    box-shadow: rgba(255, 255, 255, 0.05) 0px 0px 0px 1px;
    padding: 8px 16px;
    border-radius: 6px;
    margin-bottom: 10px;
    transition: 0.3s all ease-in-out;
    &:hover {
      box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    }
  }

  .tablist {
    list-style: none;
    margin: 0 0 20px;
    padding: 0;
    display: flex;
    gap: 15px;
    position: relative;
    padding-right: 35px;

    @media (min-width: 1400px) {
      gap: 30px;
    }
    .source-close {
      width: 20px;
      height: 20px;
      border: 1px solid var(--danger);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      position: absolute;
      right: 5px;
      top: 5px;
    }
    li {
      margin: 0;

      button {
        display: block;
        font-size: 16px;
        line-height: 20px;
        text-transform: capitalize;
        padding: 0 0 5px;
        color: var(--ink);
        border-bottom: 2px solid transparent;

        @media (min-width: 1400px) {
          font-size: 18px;
          line-height: 22px;
        }

        &.active {
          font-weight: 700;
          border-bottom: 2px solid var(--blue);
        }
      }
    }
  }

  .tab-content {
    position: relative;

    .imgs-wrap,
    .video-wrap {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px;
    }
  }

  .content-box {
    position: relative;
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;

    .head {
      margin: 0 0 10px;
      display: flex;
      align-items: center;
      gap: 10px;

      .img-box {
        width: 22px;
        flex-shrink: 0;
      }

      .text {
        font-size: 14px;
        line-height: 18px;
        display: block;
        color: var(--ink);
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .text-box {
      width: 100%;
    }
    .title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      margin: 0 0 10px;
    }

    .detail-holder {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 400px;
      padding: 15px;
      border-left: 1px solid #cdcdcd;
      border-radius: 10px 0 0 10px;
      background: var(--white);
      transform: translateX(102%);
      transition: all 0.3s ease-in-out;
      z-index: 72;

      .detail-active & {
        transform: translateX(0);
      }

      @media screen and (min-width: 1600px) {
        width: 500px;
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin: 0 0 15px;

        .title {
          font-size: 18px;
          line-height: 22px;
          font-weight: 700;
          margin: 0;
        }

        .btn-close {
          width: 25px;
          height: 25px;
          border: 1px solid var(--text-color);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }
      }

      .text-area {
        width: 100%;
        height: calc(100vh - 70px);
        overflow: auto;
        padding-right: 5px;
      }
    }
  }
  .block-heading {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    color: var(--text-color-50);
  }

  .imgs-holder {
    max-width: 100%;
    overflow-x: auto;
    .img-wrap {
      width: 100%;
      height: 200px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin-bottom: 20px;
      }
    }
  }
`;

export const ReponseMenu = styled(Menu)`
  ul {
    width: 300px;
    padding: 10px;
    border-radius: 20px;
    border: 3px solid rgba(157, 157, 157, 0.4);
    box-shadow: 0 0 10px rgba(157, 157, 157, 0.6);
  }
`;
export const MenuBtn = styled(MenuButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 50px;
  padding: 10px 6px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  text-transform: capitalize;
  border-radius: 12px;
  border: 1px solid rgba(157, 157, 157, 0.6);
  background: #f1f1f1;

  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 12px;
    background: rgba(26, 42, 108, 0.1);
  }
`;
export const StyleItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  margin: 0 0 6px;
  border-radius: 10px;
  border: 1px solid transparent;

  &.active,
  &:hover {
    border-color: var(--text-color);
    background: rgba(254, 221, 88, 0.1);
  }

  &:last-child {
    margin: 0;
  }

  .wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .icon-box {
    width: 35px;
  }

  .pro {
    display: block;
    min-width: 50px;
    padding: 5px;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--text-color);
    text-align: center;
    border-radius: 10px;
    background: var(--blue);
  }
`;
